module.exports = __webpack_public_path__ + "toGroom-we-g-w.e3736471.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-g-w.jpg
// module id = AxNk
// module chunks = 0